import * as React from 'react';
import '../css/displayLabelValue.sass';

interface FieldValueProps {
  children: React.ReactNode;
}

export default function DisplayValue(props: FieldValueProps) {
  return <span className="displayValue">{props.children}</span>;
}
